<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Roles</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button v-if="abilities.can('create', 'roles')"
            icon="add"
            @click="addRole"
            color="danger"
            type="border"
            >Add</vs-button
          >
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="6" vs-sm="4" vs-xs="12">
          <v-select v-model="per_page" :options="size_per_page" />
          <span class="ml-12 p-2">Is Client Role: </span>
          <v-select
            class="filter ml-2"
            v-model="selected_client_role"
            :options="clientRoleList"
          />
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
          <div class="p-1">
            <span>Search: </span>
          </div>

          <RoleAutocomplete
            :key="companySearchComponentKey"
            class="searchbox"
            :list="searchRole"
            :searchOn="'role'"
            @event-name="handleChildEvent"
          ></RoleAutocomplete>
          <vs-icon
            class="pl-5 pointer"
            icon="cancel"
            @click="resetRole"
            size="small"
          ></vs-icon>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="2" vs-sm="4" vs-xs="12">
           <vs-button
                    class="ml-20"
            icon="refresh"
            @click="resetAll"
            color="primary"
            >Reset</vs-button
          >

          <!-- <vs-pagination :total="Math.ceil(total/per_page)" v-model="currentx"></vs-pagination> -->
        </vs-col>
      </vs-row>

      <vs-table
        class="mb-10"
        @search="handleSearch"
        @sort="handleSort"
        v-model="selected"
        stripe
        :data="roles"
      >
        <template slot="thead">
          <!-- <vs-th sort-key="s_no">S No.</vs-th> -->
          <vs-th sort-key="role">Role</vs-th>
          <vs-th sort-key="role_description">Description</vs-th>
          <vs-th sort-key="is_client_role">Is Client Role</vs-th>
          <vs-th sort-key="status">status</vs-th>
          <vs-th sort-key="actions">Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td> -->
            <vs-td :data="data[indextr].role">
              {{ data[indextr].role }}
            </vs-td>
            <vs-td :data="data[indextr].role_description">
              {{ data[indextr].role_description }}
            </vs-td>
             <vs-td :data="data[indextr].is_client_role">
              {{ data[indextr].is_client_role }}
            </vs-td>
            <vs-td :data="data[indextr].status">
              {{ data[indextr].status }}
            </vs-td>
            <vs-td :data="data[indextr].actions">
              
              <vs-icon v-if="abilities.can('read', 'roles')"
                class="ml-10 removeButton"
                @click="viewRole(data[indextr].id)"
                color="success"
                icon="visibility"
              ></vs-icon>
              <vs-icon v-if="abilities.can('update', 'roles')"
                class="ml-10 removeButton"
                @click="editRole(data[indextr].id)"
                color="success"
                icon="edit"
              ></vs-icon>
              <vs-icon v-if="abilities.can('delete', 'roles')"
                class="ml-10 removeButton"
                @click="confirmDeleteRole(data[indextr].id)"
                color="success"
                icon="delete"
              ></vs-icon>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <template>
        <vs-pagination
          :total="Math.ceil(total / per_page)"
          v-model="currentx"
        ></vs-pagination>
      </template>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import moduleRoleManagement from "@/store/role-management/moduleRoleManagement.js";
import RoleAutocomplete from "@/components/autocomplete/RoleAutocomplete.vue";
import vSelect from "vue-select";
export default {
  data: () => ({
                            abilities : null,

    companySearchComponentKey: 0,
    selected: [],
    log: [],
    roles: [],
    selected_id: null,
    currentx: 1,
    total: 0,
    clientRoleList: ['y','n'],
    selected_client_role: "All",
    elomarkRoleTypes: [],
    size_per_page: [10, 20, 50, 100, 500],
    per_page: 10,
    paginationAttr: {
      page_no: 1,
      per_page: 10
    }
  }),
  components: {
    RoleAutocomplete,
    "v-select": vSelect,
    moduleRoleManagement
  },
  watch: {
    currentx: function(val) {
      this.paginationSetPageSize();
    },
    per_page: function(val) {
      this.paginationSetPageSize();
    },
     selected_client_role: function(val) {
          if(val != 'All')
      this.fetchRolesWithFilter();
    }
  },
  methods: {
    resetAll(){
       this.selected_client_role = 'All'
       this.resetRole()

    },
    resetRole() {
      this.fetchRoles();
      this.companySearchComponentKey += 1;
    },
    paginationSetPageSize() {
      this.paginationAttr = {
        page_no: this.currentx,
        per_page: this.per_page
      };
      this.fetchRoles();
    },
    searchRole(inputValue) {
      return this.$store
        .dispatch("rolesManagement/searchRole", inputValue)
        .then(response => {
          if (response) {
            let data = response.data;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name: data[property].role
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    addRole() {
      this.$router.push({ path: "/role/add" });
    },
    handleSearch(searching) {
      console.log(`The role searched for: ${searching}`);
    },
    handleSort(key, active) {
      console.log(`the role ordered: ${key} ${active}`);
    },
    viewRole(id) {
      this.$router.replace("/role/" + id);
    },
    editRole(id) {
      this.$router.replace("/role/edit/" + id);
    },
    handleChildEvent() {
      this.roles = moduleRoleManagement.state.roles.datas;
    },
    confirmDeleteRole(id) {
      this.selected_id = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Role`,
        accept: this.deleteRole,
        acceptText: "Delete"
      });
    },
    deleteRole() {
      this.$store
        .dispatch("rolesManagement/removeRole", this.selected_id)
        .then(res => {
          if (res.data.status == "success") {
            this.fetchRoles();
            this.showDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Role Deleted",
        text: "The User was successfully deleted"
      });
    },
    fetchRoles() {
      this.$store
        .dispatch(
          "rolesManagement/fetchAllRoles",
          this.paginationAttr
        )
        .then(res => {
          console.log();
          this.roles =
            moduleRoleManagement.state.roles.datas;
          this.total = moduleRoleManagement.state.roles.total;
          this.per_page =
            moduleRoleManagement.state.roles.per_page;
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchRolesWithFilter() {
      let filter = {}
      filter.is_client_role = this.selected_client_role
      this.$store
        .dispatch(
          "rolesManagement/fetchAllRolesWithFilter",
          filter
        )
        .then(res => {
          this.roles =
            moduleRoleManagement.state.roles;
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  },
  mounted() {
    this.fetchRoles();
  },
  created() {
        var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });  
    if (!moduleRoleManagement.isRegistered) {
      this.$store.registerModule(
        "rolesManagement",
        moduleRoleManagement
      );
      moduleRoleManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-roles
  .con-btns-role
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-rolex
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
